/**
 * Shows a failure screen when a user's state is not valid
 */
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { Namespace, Translate, useTranslate } from "localization";
import { Button } from "minimum-ui/core";
import styled from "styled-components";
import { H4M } from "typography/headers";

import { userSelectors } from "store/user/userSelectors";

import { useAppSelector } from "utilities/hooks/general";
import urls from "utilities/urls";

import Page from "Layout/Page/Auth";

import Response from "../Response";
import { useLogout } from "../react";

const AccountCheck: React.FC = ({ children }) => {
  const { translate } = useTranslate(Namespace.AUTHENTICATION);
  const invalidLogin = useAppSelector(userSelectors.loginInvalid);
  const logout = useLogout();
  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    async function run() {
      await logout();
      navigate(urls.login());
    }

    void run();
  }, [navigate, logout]);

  if (!invalidLogin) {
    return <>{children}</>;
  }

  return (
    <Page name="">
      <Response message={translate("accountNotFound")} isError={true}>
        <H4M>
          <Translate
            i18nKey="emailSupport"
            namespace={Namespace.AUTHENTICATION}
            placeholders={{ email: "support@minimum.com" }}
            components={{ strong: <strong /> }}
          />
        </H4M>
        <Logout onClick={handleLogout}>{translate("logout")}</Logout>
      </Response>
    </Page>
  );
};

const Logout = styled(Button).attrs({ variant: "outlined", size: "large" })`
  margin-top: 24px;
  width: 100%;
`;

export default AccountCheck;
